import {
    Controller
} from "stimulus"
import uniqid from 'uniqid'
/**
 * Wraps a group of collapse components to crete an accordion.
 * Any collapse component that opens inside the accordion will
 * cause all collapse targets to close.
 *
 * The collapse controllers should have a open->accordion#handleOpened
 * action on their root element.
 */
export default class extends Controller
{
    static targets = ['collapse']

    connect() {
        setTimeout(() => {
            let firstTarget = this.collapseTargets[0]
            if (firstTarget) {
                let firstController = app.getControllerForElementAndIdentifier(firstTarget, 'collapse')
                if(firstController.canAutoOpen) {
                    firstController.open()
                }
            }
        }, 1)
    }

    /**
     * Loop through all collapse targets and close them
     * all except the controller firing the event.
     * @param srcElement
     */
    handleOpened({srcElement})
    {
        let openedController = app.getControllerForElementAndIdentifier(srcElement, 'collapse')
        this.collapseTargets.forEach(el => {
            let collapseController = app.getControllerForElementAndIdentifier(el, 'collapse')
            if (collapseController.id !== openedController.id) {
                collapseController.close();
            }
        })
    }
}
